import { Button, Flex, Text, Tooltip } from '@retracedgmbh/ui-components-lib';
import useTranslator from '@/hooks/useTranslator';

interface AIProcessingStatProps {
  onOpen: () => void;
  percentage: number;
  isProcessing: boolean;
  classifiedCount: number;
}

export function AIProcessingStat({
  onOpen,
  percentage,
  isProcessing,
  classifiedCount,
}: AIProcessingStatProps) {
  const { getTranslation } = useTranslator({ page: 'ai-processing' });

  return (
    <Tooltip title={getTranslation('stat.tooltip')} placement='bottom'>
      <Button variant='ghost' onClick={onOpen}>
        <Flex gap='sm' alignItems='center'>
          <span className='tw:relative'>
            {isProcessing ? (
              <i className='fa-light fa-circle-notch tw:animate-spin tw:text-content-info-ai-bold' />
            ) : (
              <i className='fa-regular fa-sparkles tw:text-content-info-ai-bold' />
            )}
            {classifiedCount > 0 && (
              <span className='tw:absolute tw:-top-2 tw:-right-2 tw:flex tw:items-center tw:justify-center tw:min-w-4 tw:h-4 tw:rounded-full tw:bg-content-info-ai-bold tw:px-0.5'>
                <Text
                  as='span'
                  className='tw:text-[10px] tw:leading-none tw:text-white tw:font-semibold'
                >
                  {classifiedCount}
                </Text>
              </span>
            )}
          </span>
          {isProcessing && (
            <Text
              size='base'
              weight='semibold'
              className='tw:text-content-info-ai-bold'
            >
              {getTranslation('stat.percentComplete', { percentage })}
            </Text>
          )}
        </Flex>
      </Button>
    </Tooltip>
  );
}
